import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, Box, CircularProgress } from '@hub-la/design-system';
import { useTranslation } from 'react-i18next';

const SectionProgress = ({
  count,
  progress
}) => {
  const {
    t
  } = useTranslation();
  return jsxs(Stack, Object.assign({
    direction: "row",
    alignItems: "center",
    gap: 2
  }, {
    children: [jsxs(Text, Object.assign({
      variant: "caption",
      color: "outline",
      display: "flex",
      alignItems: "center",
      whiteSpace: "pre"
    }, {
      children: [count, " ", t('postDetail.sidebar.sectinProgress.counter')]
    })), jsx(Box, Object.assign({
      color: "white",
      width: 18,
      height: 18,
      mx: 2
    }, {
      children: jsx(CircularProgress, {
        value: progress !== null && progress !== void 0 ? progress : 0,
        size: 18
      })
    }))]
  }));
};

export { SectionProgress };
